'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarMainInfo = renderWithRef('PriceBarMainInfo', null, (o, n)=>{
    let { children: a } = o;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        classNames: new Set([
            'swan-price-bar-main-info'
        ]),
        props: o,
        children: a
    });
});

export { PriceBarMainInfo };
